import * as CryptoJS from "crypto-js";

export const decrypt = (encrypted) => {
    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_ENCRYPT_SECRET)
            .toString(CryptoJS.enc.Utf8);
        return JSON.parse(bytes);
    } catch (e) {
        console.error('ENCRYPTION ERR - ', e)
        console.error('text= . ',encrypted)
        return null
    }
}


export const encrypt = (data) => {
    try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_ENCRYPT_SECRET)
            .toString();
    } catch (e) {
        console.error('ENCRYPTION ERR - ', e)
        return null
    }
}


export const afterDecimal = (num) => {
    try {
        if (Number.isInteger(num)) {
            return 0;
        }

        return num.toString().split('.')[1].length;
    } catch (e) {
        return 0;
    }
}


export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.error(e)
    }
}
